/**
 * /finishMagicLink — Fallback page for users who tap the magic-link
 * email on a device that doesn't have the IC App installed (typically
 * desktop). On phones with the app installed, Android app links / iOS
 * Universal Links intercept the URL and skip this page entirely.
 */
export default function FinishMagicLinkPage() {
  const appStoreUrl = 'https://apps.apple.com/ca/app/id6771061626';
  const playStoreUrl =
    'https://play.google.com/store/apps/details?id=com.inspectcanada';

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-8">
        <div className="flex justify-center mb-5">
          <div className="h-14 w-14 rounded-2xl bg-red-700 flex items-center justify-center text-white text-2xl font-bold">
            IC
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-2">
          Open this link on your phone
        </h1>
        <p className="text-sm text-slate-600 text-center leading-relaxed mb-6">
          This sign-in link works inside the Inspect Canada app. Open it on the
          phone where you've installed the app — it will sign you in and load
          your inspection report automatically.
        </p>

        <div className="space-y-3">
          <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-black text-white py-3 rounded-xl font-semibold text-sm hover:opacity-90 transition"
          >
            ⬇ Get it on the App Store
          </a>
          <a
            href={playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-blue-600 text-white py-3 rounded-xl font-semibold text-sm hover:bg-blue-700 transition"
          >
            ⬇ Get it on Google Play
          </a>
        </div>

        <p className="text-xs text-slate-500 text-center mt-6 leading-relaxed">
          Already have the app installed? Open this email on that phone and tap
          the sign-in link from there. The link is single-use and expires in
          1 hour.
        </p>
      </div>
    </div>
  );
}
